'use strict';

import {getVueTemplate} from '../_imports/utils/utils.common';
import MediaImage from '../vue/media-image.main';

const mediaVideoThumbnail = {
    template: getVueTemplate('media-video-thumbnail'),
    components: {
        MediaImage
    },
    props: {
        video: Object,
        isGated: Boolean,
        gatedButtonLabel: String,
        ctaTracking: String,
        aspectRatio: String
    },
    computed: {
        videoProvider() {
            return this.video ? this.video.provider : '';
        },
        videoThumbnail() {
            return this.video ? this.video.thumbnail : '';
        },
        videoThumbnailSrc() {
            return this.video ? this.video.thumbnailSrc : '';
        }
    },
    methods: {
        thumbnailIsLoaded() {
            this.$emit('thumbnail-is-loaded');
        },
        renderAmAttribute() {
            return this.isGated ? 'is-gated' : '';
        }
    }
};


export default mediaVideoThumbnail;